import { styled } from '@mui/material/styles';
import { Form } from 'formik';

const StyledFormWrapper = styled(Form)(() => ({
  maxWidth: '500px',
  margin: 'auto',
  width: '100%',
  paddingLeft: '6px',
  paddingRight: '6px',
  boxSizing: 'border-box',
}));

export default StyledFormWrapper;
